/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 184a00ce8c0820b9f30e843b83a02cfbde1f2078e2c79fbcd6e62e412bf38c30
 */
import {
  base_colorContentBorder,
  blue100,
  blue400,
  notification_colorAlert,
  purple400,
  tag_colorTagBlueText,
  tag_colorTagNewBackground,
  tag_colorTagNewText,
  tag_colorTagPendingBackground,
  tag_colorTagPendingText,
  tag_colorTagSevereBackground,
  tag_colorTagSevereText,
  text_colorTextPrimary,
  text_colorTextSecondary,
  yellow200,
} from 'ext-ui/style/colors'
import {
  spacing,
} from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  border-radius: 8px;
  border-style: solid;
  border-width: 1px;
  display: flex;
  font-family: ${font_family_weight_regular};
  font-size: ${font_size_md};
  gap: ${spacing(3)};
  line-height: 18px;
  padding-block: ${spacing(4)};
  padding-inline: ${spacing(5)};

  .content-row {
    display: flex;
    gap: ${spacing(3)};
  }

  .content-stack {
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
  }

  .actions {
    display: flex;
    gap: ${spacing(3)};
    justify-content: flex-end;
  }

  .icon {
    color: currentColor;
    flex-shrink: 0;
  }

  .linkText {
    font-family: ${font_family_weight_regular};
  }

  .subtitle {
    font-family: ${font_family_weight_regular};
  }

  .title {
    font-family: ${font_family_weight_medium};
  }

  &.has-actions {
    flex-direction: column;
    gap: ${spacing(3)};
  }

  &.monochrome .icon {
    color: ${text_colorTextSecondary};
  }

  &.monochrome .subtitle {
    color: ${text_colorTextSecondary};
  }

  &.monochrome .title {
    color: ${text_colorTextPrimary};
  }

  &.monochrome {
    border-color: ${base_colorContentBorder};
  }

  &.ai {
    background: ${tag_colorTagNewBackground};
  }

  &.severe {
    background: ${tag_colorTagSevereBackground};
  }

  &.soft {
    background: ${blue100};
  }

  &.warning {
    background: ${tag_colorTagPendingBackground};
  }

  &.color.soft {
    border-color: ${blue400};
    color: ${tag_colorTagBlueText};
  }

  &.color.warning {
    border-color: ${yellow200};
    color: ${tag_colorTagPendingText};
  }

  &.color.severe {
    border-color: ${notification_colorAlert};
    color: ${tag_colorTagSevereText};
  }

  &.color.ai {
    border-color: ${purple400};
    color: ${tag_colorTagNewText};
  }
`
